import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Anchor, Card, Group, SimpleGrid, Text, ThemeIcon } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import { api, ATTENDANCE_TEAM_QUERY_KEY } from '../../lib/api';
import { AttendancePunchPanel } from '../../components/attendance/AttendancePunchPanel';
import { TeamNowList } from '../../components/attendance/TeamNowList';

/**
 * Startseite: Stempeln und „Team jetzt" kompakt (v1.405.0). Links die eigenen Knöpfe, rechts wer
 * arbeitet, Pause macht oder weg ist.
 */
export function AttendanceWidget() {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: ATTENDANCE_TEAM_QUERY_KEY,
    queryFn: () => api.getTeamNow(),
    refetchInterval: 60_000,
  });
  const present = (data?.members ?? []).filter((m) => m.state !== 'OFF');

  return (
    <Card withBorder radius="md" p="md">
      <Group justify="space-between" mb="sm">
        <Group gap="xs">
          <ThemeIcon size="sm" color="green" variant="light" radius="xl">
            <IconClock size={14} />
          </ThemeIcon>
          <Text size="sm" c="dimmed" tt="uppercase" fw={500}>
            Anwesenheit
          </Text>
        </Group>
        <Anchor size="xs" c="dimmed" onClick={() => navigate('/anwesenheit')}>
          Team jetzt →
        </Anchor>
      </Group>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
        <AttendancePunchPanel />
        <div>
          <Text size="xs" c="dimmed" mb={6}>
            {data
              ? `${data.counts.WORKING} arbeiten · ${data.counts.ON_BREAK} Pause · ${data.counts.OFF} weg`
              : 'Team wird geladen …'}
          </Text>
          {present.length > 0 ? (
            <TeamNowList members={present.slice(0, 8)} compact />
          ) : (
            data && (
              <Text size="sm" c="dimmed">
                Gerade ist niemand eingestempelt.
              </Text>
            )
          )}
        </div>
      </SimpleGrid>
    </Card>
  );
}
